let moreLess = document.querySelector('.read-more-less-link');

if (moreLess) {
  moreLess.addEventListener('click', (e) => {
    e.preventDefault();
    let short = document.querySelector('.short-description');
    let complete = document.querySelector('.complete-description');
    let button = document.querySelector('.read-more-less-link');

    if (short.style.display === 'none') {
      short.style.display = 'inline';
      button.innerHTML = ' + <span>Read More</span>';
      if (complete) {
        complete.style.display = 'none';
      }
    } else {
      short.style.display = 'none';
      button.innerHTML = ' - <span>Read Less</span>';
      if (complete) {
        complete.style.display = 'inline';
      }
    }
  });
}
